import { Reveal, SectionLabel, Counter } from "@/components/site/bits";
import { X, Check } from "lucide-react";

const TRAD = ["Manual Work", "Slow Delivery", "Generic Solutions", "High Cost"];
const NINE = ["AI Powered", "Faster Delivery", "Customized Solutions", "Better ROI"];

const STATS = [
  { to: 240, suffix: "+", label: "Projects Delivered" },
  { to: 98, suffix: "%", label: "Client Satisfaction" },
  { to: 52000, suffix: "+", label: "Automation Hours Saved" },
  { to: 3, suffix: "x", label: "Avg Business Growth" },
];

export default function WhyChoose() {
  return (
    <section id="why" className="relative py-28 px-6" data-testid="why-choose">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionLabel>Why Choose 9nocAI</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight max-w-2xl">
            The difference is <span className="text-gradient">intelligence</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <Reveal>
            <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-8" data-testid="compare-traditional">
              <h3 className="font-display text-xl font-semibold text-white/60">Traditional Agency</h3>
              <ul className="mt-6 space-y-4">
                {TRAD.map((t) => (
                  <li key={t} className="flex items-center gap-3 text-white/50">
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-red-500/10">
                      <X className="h-3.5 w-3.5 text-red-400" />
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative rounded-2xl p-8 glass border-[#00E5FF]/30 overflow-hidden" data-testid="compare-9nocai">
              <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#00E5FF]/20 blur-3xl" />
              <h3 className="font-display text-xl font-semibold text-gradient">9nocAI</h3>
              <ul className="mt-6 space-y-4">
                {NINE.map((t) => (
                  <li key={t} className="flex items-center gap-3 text-white">
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-[#00FFB2]/15">
                      <Check className="h-3.5 w-3.5 text-[#00FFB2]" />
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="rounded-2xl glass p-7 text-center" data-testid={`stat-${i}`}>
                <div className="font-display text-4xl md:text-5xl font-bold text-gradient">
                  <Counter to={s.to} suffix={s.suffix} />
                </div>
                <div className="mt-2 text-sm text-white/60">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
